/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inserting_Blank_FramesInputs */

const en_inserting_blank_frames = /** @type {(inputs: Inserting_Blank_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserting blank frames...`)
};

const fr_inserting_blank_frames = /** @type {(inputs: Inserting_Blank_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertion d’images vides...`)
};

const de_inserting_blank_frames = /** @type {(inputs: Inserting_Blank_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leere Frames einfügen...`)
};

const it_inserting_blank_frames = /** @type {(inputs: Inserting_Blank_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserimento di cornici vuote...`)
};

const ru_inserting_blank_frames = /** @type {(inputs: Inserting_Blank_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставка пустых рамок...`)
};

const es_inserting_blank_frames = /** @type {(inputs: Inserting_Blank_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar marcos en blanco...`)
};

const zh_cn2_inserting_blank_frames = /** @type {(inputs: Inserting_Blank_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插入空白帧...`)
};

const ja_inserting_blank_frames = /** @type {(inputs: Inserting_Blank_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空白のフレームを挿入しています...`)
};

const hi_inserting_blank_frames = /** @type {(inputs: Inserting_Blank_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खाली फ्रेम डाले जा रहे हैं...`)
};

const pt_pt2_inserting_blank_frames = /** @type {(inputs: Inserting_Blank_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserindo molduras em branco...`)
};

/**
* | output |
* | --- |
* | "Inserting blank frames..." |
*
* @param {Inserting_Blank_FramesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const inserting_blank_frames = /** @type {((inputs?: Inserting_Blank_FramesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inserting_Blank_FramesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_inserting_blank_frames(inputs)
	if (locale === "de") return de_inserting_blank_frames(inputs)
	if (locale === "it") return it_inserting_blank_frames(inputs)
	if (locale === "ru") return ru_inserting_blank_frames(inputs)
	if (locale === "es") return es_inserting_blank_frames(inputs)
	if (locale === "zh-CN") return zh_cn2_inserting_blank_frames(inputs)
	if (locale === "ja") return ja_inserting_blank_frames(inputs)
	if (locale === "hi") return hi_inserting_blank_frames(inputs)
	if (locale === "pt-PT") return pt_pt2_inserting_blank_frames(inputs)
	return en_inserting_blank_frames(inputs)
});